export const LogoComponent = () => {
	return (
		<div className="logo">
			<a href="/landing">
				<span className="thin">RUS</span>
				<span className="bold">ETFS</span>
			</a>
		</div>
	);
}